import React from 'react';
import TsSprintDetailItemTitle from './TsSprintDetailItemTitle.jsx';
import TsSprintDetailItemCol from './TsSprintDetailItemCol.jsx';

class TsSprintDetailItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			all: {
				count: 0,
				percent: 0,
			},
			byMember: {},
		};

		this.round = this.round.bind(this);
		this.getRoundedValue = this.getRoundedValue.bind(this);
	}

	componentWillMount() {
		// On appelle la fonction pour update les informations
		this.updateStateFromProps(this);
	}

	updateStateFromProps(elem) {
		// Si l'on ne souhaite pas afficher les images
		if (! elem.props.img) {
			// On instancie un objet qui va contenir toutes les statistiques sur pour chaque membre
			let objInfoByMembers = {};

			// On instancie le compteur total
			let countAll = 0;
			
			// On parcourt les membres
			for (const memberId in elem.props.members) {
				// On instancie l'objet par membre
				objInfoByMembers[memberId] = {
					count: 0,
					percent: 0,
				};
			}

			// On parcourt les cartes
			for (const cardOrder in elem.props.cards) {
				// On extrait le carte courante
				const micro = elem.props.cards[cardOrder];

				// En fonction de la méthode de test
				switch (elem.props.testBy) {
					// Si on doit tester les labels
					case 'labels': {
						// On récupère les labels de la carte
						const labels = micro.labels;

						// On instancie un indicateur de match
						let hasMatched = false;

						// On instancie un indicateur de match avec la regex de non match
						let hasMatchedWithNot = false;

						// On parcourt les labels
						labels.map((label) => {
							// Si on a une regex à matcher
							if (elem.props.regexLabelMatch) {
								// Si le nom du label match avec la regex
								if (label.name.match(elem.props.regexLabelMatch)) {
									// On indique que ça a matché
									hasMatched = true;
								}
							} else {
								hasMatched = true;
							}

							// Si on a une regex à ne pas matcher
							if (elem.props.regexLabelNotMatch) {
								// Si le nom du label match avec la regex
								if (label.name.match(elem.props.regexLabelNotMatch)) {
									// On indique que ça a matché
									hasMatchedWithNot = true;
								}
							} else {
								hasMatchedWithNot = false;
							}
						});

						// Si ça a matché avec la regex de match, et que ça n'a pas matché avec la regex de non match
						if (hasMatched && ! hasMatchedWithNot) {
							// On augmente le compteur total
							countAll += 1;

							// On parcourt les membres de la carte
							micro.idMembers.map((idMember) => {
								// Si le membre de la carte est un membre de notre composant
								if (elem.props.members.hasOwnProperty(idMember)) {
									// On augmente le compteur du membre
									objInfoByMembers[idMember].count += 1;
								}
							});
						}

						break;
					}

					// Si on doit tester les dates limites
					case 'dueDate': {
						// Si la carte a une date limite
						if (micro.due !== null) {
							// Si la date limite a été respectée
							if (micro.dueComplete === true) {
								// On augmente le compteur total
								countAll += 1;

								// On parcourt les membres de la carte
								micro.idMembers.map((idMember) => {
									// Si le membre de la carte est un membre de notre composant
									if (elem.props.members.hasOwnProperty(idMember)) {
										// On augmente le compteur du membre
										objInfoByMembers[idMember].count += 1;
									}
								});
							}
						}
						
						break;
					}

					default: {
						break;
					}
				}
			}

			// On calcule le nombre de cartes
			const numberOfCards = Object.keys(elem.props.cards).length;

			// Par défaut on indique 0%
			let allPercent = 0;

			// S'il y a au moins 1 carte
			if (numberOfCards > 0) {
				// On calcule le pourcentage global
				allPercent = elem.getRoundedValue(countAll * 100 / numberOfCards);
			}

			// S'il y a eu au moins 1 carte
			if (countAll > 0) {
				// On parcourt les infos récupérées par membre
				for (const memberId in objInfoByMembers) {
					// On récupère les infos courantes
					const currentInfo = objInfoByMembers[memberId];
					
					// On calcule son pourcentage
					const memberPercent = elem.getRoundedValue(currentInfo.count * 100 / countAll);

					// On met à jour le pourcentage
					currentInfo.percent = memberPercent;
				}
			}

			elem.setState({
				all: {
					count: countAll,
					percent: allPercent,
				},
				byMember: objInfoByMembers,
			});
		}
	}

	round(value, decimals) {
		return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
	}

	getRoundedValue(value) {
		return this.round(this.round(this.round(this.round(value, 3), 2), 1), 0);
	}

	render () {
		// On instancie une variable qui va contenir le JSX des colonnes
		let jsxItemCols = [];

		// Si l'on souhaite afficher les images des membres
		if (this.props.members) {

			// Par défaut la première colonne n'est pas bold
			let isFirstColBold = false;

			// Si on a précisé une info sur bold
			if (typeof this.props.bold !== 'undefined') {
				// Si on veut que toutes les colonnes soient bold
				if (this.props.bold === true) {
					isFirstColBold = true;

				// Si on précise certaines colonnes comme bold, et que la première en fait partie
				} else if (Array.isArray(this.props.bold) && this.props.bold.indexOf(0) > -1) {
					isFirstColBold = true;
				}
			}

			// On instancie une variable qui va contenir la catégorie
			let tooltipCategory = '';

			// Si title est dans les props
			if (this.props.hasOwnProperty('title')) {
				// On ajoute la catégorie
				tooltipCategory = this.props.title;
			}

			// Si l'on souhaite afficher les images
			if (this.props.img) {
				// On ajoute une colonne vide
				jsxItemCols.push(
					<TsSprintDetailItemCol 
						img={this.props.img}
						imgSrc={null}
						content='Sprint'
						bold={isFirstColBold}
						key={this.props.aloneKey}
						showTooltip={false}
					/>
				);
			} else {
				// On instancie une variable qui contient le pourcentage total de la catégorie
				const categoryPercent = `${this.state.all.percent} %`;
				
				// On intancie un objet qui va contenir les éléments à placer dans le template
				const tooltipTemplateValues = {
					percent: categoryPercent,
					category: tooltipCategory,
				};

				// On ajoute la colonne totale
				jsxItemCols.push(
					<TsSprintDetailItemCol 
						img={this.props.img}
						imgSrc={null}
						content={categoryPercent}
						bold={isFirstColBold}
						key={this.props.aloneKey}
						showTooltip={true}
						tooltipTemplate={"{percent} du sprint sont des cartes {category}"}
						tooltipTemplateValues={tooltipTemplateValues}
					/>
				);
			}

			// On instancie une compteur
			let i = 1;

			// On parcourt les membres
			for (const memberId in this.props.members) {
				// On récupère le membre courant
				const currentMember = this.props.members[memberId];

				// On instancie une variable qui va contenir le contenu
				let contentMember = currentMember.initials;

				// On instancie un indicateur pour l'affichage de la tooltip
				let showTooltip = false;

				// Si l'on ne souhaite pas afficher les images
				if (! this.props.img) {
					// Si l'on n'autorise pas l'affichage du 0% et que l'utlisateur est à 0%
					if (this.props.isZeroPercentAllowed === false && this.state.byMember[memberId].percent === 0) {
						contentMember = '-';
					} else {
						contentMember = `${this.state.byMember[memberId].percent} %`;
						// On affiche une tooltip
						showTooltip = true;
					}
				}

				// Par défaut les colonnes ne sont pas bold
				let isBold = false;

				// Si on a précisé une info sur bold
				if (typeof this.props.bold !== 'undefined') {
					// Si on veut que toutes les colonnes soient bold
					if (this.props.bold === true) {
						isBold = true;

					// Si on précise certaines colonnes comme bold, et que celle-ci en fait partie
					} else if (Array.isArray(this.props.bold) && this.props.bold.indexOf(i) > -1) {
						isBold = true;
					}
				}

				// On intancie un objet qui va contenir les éléments à placer dans le template
				const tooltipTemplateValues = {
					percent: contentMember,
					category: tooltipCategory,
					member: currentMember.fullName,
				};

				jsxItemCols.push(
					<TsSprintDetailItemCol 
						img={this.props.img}
						imgSrc={currentMember.avatar30}
						content={contentMember}
						bold={isBold}
						key={memberId}
						showTooltip={showTooltip}
						tooltipTemplate={"{percent} des cartes {category} ont été faites par {member}"}
						tooltipTemplateValues={tooltipTemplateValues}
					/>
				);

				// On augmente notre compteur
				i += 1;
			}
		}

		return (
			<div>
				<div className="sprintDetailItem row pll prl ptm pbm">

					<TsSprintDetailItemTitle title={this.props.title} />

					{jsxItemCols}
				</div>
			</div>
		);
	}
}

export default TsSprintDetailItem;


// WEBPACK FOOTER //
// ./src/js/TsSprintDetailItem.jsx